import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {ConventionCenter} from '../models/convention-center';

@Injectable({
  providedIn: 'root'
})
export class ConventionCenterService {

  public conventionCenters: ConventionCenter[] = [];
  public conventionCenterCurrent: ConventionCenter;

  constructor (private db: AngularFirestore) { }

  select () {
    return this.db.collection<ConventionCenter>('sbccv_convention_centers', ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }

  load () {
    return this.db.collection<ConventionCenter>('sbccv_convention_centers', ref => ref.orderBy('name', 'asc')).get();
  }

  getById (id) {
    return this.db.doc<ConventionCenter>('sbccv_convention_centers/' + id)
      .get();
  }

  insert (entity: ConventionCenter) {
    return this.db.collection('sbccv_convention_centers').add(Object.assign({}, entity));
  }

  update (entity: ConventionCenter) {
    return this.db.collection('sbccv_convention_centers').doc(entity.id).update(Object.assign({}, entity));
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_convention_centers').doc(entity_id).delete();
  }

  loadConventionCenters (current_id) {
    this.conventionCenters = [];
    this.load()
      .subscribe((result) => {
        result.forEach((item) => {
          let entity = new ConventionCenter();
          entity.id = item.id;
          entity.name = item.data().name;
          entity.city = item.data().city;
          entity.state = item.data().state;
          entity.address = item.data().address;
          entity.rooms = item.data().rooms;
          this.conventionCenters.push(entity);
          if(entity.id === current_id){
            this.conventionCenterCurrent = entity;
          }
        });
      })
  }

}
